var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"main",class:_vm.b(),style:(_vm.styleSizeName),on:{"click":_vm.handleClick}},[_c('p',{style:(_vm.styleName)},[_vm._v(_vm._s(_vm.nowDate))])])}
var staticRenderFns = []

export { render, staticRenderFns }